import { isEmpty } from 'lodash-es';
import { TooltipInfo } from '../../../components/ui/tooltip.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { api } from '../../../utils/api.ts';
import { useExplorerView } from './use-explorer-query-params';

export const useExplorerTotalSummary = () => {
    const { t } = useLocale('explorer');

    // We need to validate if the user applied any filters
    const { filters, state, combinedFilters } = useExplorerView();

    const { window, billingStatus, customDateRange } = state;
    const hasFilters = Object.keys(filters).some((key) => !isEmpty(filters[key as keyof typeof filters]));

    const { data, isLoading } = api.platoUser.query.explorer.getExplorerSummary.getTotalWithFilters.useQuery(
        {
            filters: combinedFilters,
            window,
            billingStatus,
            customDateRange,
        },
        {
            enabled: hasFilters,
            keepPreviousData: hasFilters,
        },
    );

    if (isLoading || !data || !hasFilters) {
        return {};
    }

    return {
        summaryHeader: {
            name: (
                <div className="flex items-center gap-1">
                    {t('total_summary__name')}
                    <TooltipInfo side="right">{t('total_summary__name_tooltip')}</TooltipInfo>
                </div>
            ),
            ...data,
        },
    };
};
